import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import Styles from "../../../Styles.module.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { isMobileDevice, isTabletDevice } from "../../../utils/AppUtils";

function FindHomeSteps({ steps, xlUp }) {
  return (
    <React.Fragment>
      {steps.map((data, index) => {
        return (
          <Grid
            item
            xs={2}
            container
            key={index}
            justifyContent="center"
            style={{
              height: isMobileDevice() ? "100%" : "90%",
              minWidth: isMobileDevice() && "40%",
            }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{
                height:
                  isMobileDevice() || isTabletDevice()
                    ? "34%"
                    : xlUp
                    ? "45%"
                    : "65%",
              }}
            >
              <img
                src={data.image}
                style={{
                  width: isMobileDevice() ? "60%" : xlUp ? "65%" : "85%",
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                height: isTabletDevice() ? "15%" : xlUp ? "20%" : "16%",
                textAlign: "center",
              }}
            >
              <Typography
                className={Styles.navyBlueColor}
                style={{ fontSize: xlUp ? 12 : 8 }}
              >
                {data.description}
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={4}
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              style={{
                backgroundColor: "#F5F6F8",
                height: isMobileDevice() ? 40 : xlUp ? 48 : 32,
                width: isMobileDevice() ? 40 : xlUp ? 42 : 32,
                borderRadius: "50%",
                textAlign: "center",
              }}
            >
              <Typography
                className={clsx(Styles.navyBlueColor, Styles.font14)}
                style={{ fontWeight: 500 }}
              >
                {index + 1}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
    </React.Fragment>
  );
}

export default function FindHomeJourney({
  xlUp,
  setShowFindHomeJourney,
  setShowFullJourney,
}) {
  const steps = [
    {
      description: "Asses your personal & financial readiness",
      image: "/images/find-home-step1.svg",
    },
    {
      description:
        "Find a lender and obtain pre-qualification for home mortgage",
      image: "/images/find-home-step2.svg",
    },
    {
      description: "Connect with realtors",
      image: "/images/find-home-step3.svg",
    },
    {
      description: "Sign buyer/broker agreement",
      image: "/images/find-home-step4.svg",
    },
    {
      description: "Start your home search",
      image: "/images/find-home-step5.svg",
    },
    {
      description: "Submit an offer",
      image: "/images/find-home-step6.svg",
    },
  ];
  return (
    <Grid
      container
      spacing={!isMobileDevice() && 4}
      style={{
        // height: xlUp ? "20.75rem" : "18.5rem",
        height: isMobileDevice() ? 251 : xlUp ? "18.5rem" : 282,
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          padding: isMobileDevice() ? 0 : "10px 0px 0px 20px",
          height: isMobileDevice() ? 0 : xlUp ? "12%" : "15%",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          style={{
            textTransform: "capitalize",
          }}
          className={Styles.primaryTxtAccentForce}
          onClick={() => {
            setShowFindHomeJourney(false);
            setShowFullJourney(true);
          }}
        >
          Find Your Home
        </Button>
      </Grid>
      {isMobileDevice() ? (
        <Grid
          container
          item
          xs={12}
          style={
            isMobileDevice()
              ? {
                  display: "flex",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }
              : {}
          }
        >
          <FindHomeSteps steps={steps} xlUp={xlUp} />
        </Grid>
      ) : (
        <FindHomeSteps steps={steps} xlUp={xlUp} />
      )}
    </Grid>
  );
}
